/*
 *
 *  * Copyright (c) 2024 TheDeck.com - All Rights Reserved
 *  * Unauthorized copying of this file, via any medium is strictly prohibited
 *  * Proprietary and confidential
 *  *
 *  * Created on 11 05 2024
 *
 */

import React, { useState, useEffect } from 'react';
import './App.css';
import Split from 'react-split';

const publicUrl = process.env.PUBLIC_URL;
const demoHome = publicUrl + "/img/demo_home.png";

function App() {
  const [isSingleColumn, setIsSingleColumn] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const minWidth = 600;
      const screenWidth = window.innerWidth;

      setIsSingleColumn(screenWidth < minWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const leftColumnContent = (
    <div className="left-column">
      <img src={demoHome} alt="Demo Home" className="App__img" />
    </div>
  );

  const rightColumnContent = (
    <div className="right-column">
      <h1 className="App__title">The Deck</h1>
      <h2 className="App__subtitle">Experience the thrill of the game in the palm of your hand</h2>
      <ul className="App__list">
        <li>🎮 Growing library of most famous party games</li>
        <li>⚡️ Fast and secure gaming leveraging local network connection</li>
        <li>👻 Customize your profile, compete with friends and get amazing unique badges</li>
      </ul>
      <div className="App__buttons">
        <a href="https://apps.apple.com/us/app/the-deck-play/id6448377728" className="App__button">
          <img className="App__icon" src={process.env.PUBLIC_URL + '/img/app-store.png'} alt="Download on the App Store" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.thedeck.app" className="App__button">
          <img className="App__icon" src={process.env.PUBLIC_URL + '/img/google-play.png'} alt="Get it on Google Play" />
        </a>
      </div>
      <p className="App__policy">
        <a href={publicUrl + "/privacy.html"}>Privacy policy @ The Deck 2024</a>
      </p>
    </div>
  );

  return (
    <div className="App" data-testid="app-component">
      {isSingleColumn ? (
        <div className="single-column">
          {rightColumnContent}
          {leftColumnContent}
        </div>
      ) : (
        <Split
          className="split"
          sizes={[50, 50]}
          minSize={[100, 200]}
          gutterSize={10}
        >
          {leftColumnContent}
          {rightColumnContent}
        </Split>
      )}
    </div>
  );
}

export default App;

